import { axiosAuth } from './axiosInstances'
import axios from 'axios';
import { BASE_URL } from '../settings';

// KHAN-230: Media is a single REST resource, `media/`:
//   GET    media/            list (?type=image|audio|video, ?gallery-type=<n>)
//   GET    media/{id}/       one row
//   POST   media/            upload (multipart: file, galleryType)
//   PATCH  media/{id}/       replace the file / flip isfunreadMedia
//   DELETE media/{id}/       delete
// Every row carries `file` and `url` (same relative path under /api/media/),
// so uploading is one request: the response already has the route that the
// old second step (Media/upload/) used to resolve.

/**
 * Resolve an existing media id to its row (`url` is the public file route).
 * It used to be POST Media/upload/ {name: id} -> {file_route}; `file_route`
 * is still returned for callers that read it.
 */
export async function getMedia(id) {
  const response = await axiosAuth().get('media/' + id + '/')
  return {
    ...response,
    data: { ...response.data, file_route: response.data.url },
  }
}

export async function save_Image(file, galleryType) {
  const formFile = new FormData();
  formFile.append('file', file);
  if (galleryType !== undefined) {
    formFile.append('galleryType', galleryType);
  }
  return axiosAuth().post('media/', formFile);
}

export async function list() {
  return axiosAuth().get('media/')
}

/**
 * Obtener imágenes por tipo de galería
 */
export const getMediaByType = async (galleryType, token) => {
  try {
    const response = await axios.get(
      `${BASE_URL}media/`,
      {
        params: { 'gallery-type': galleryType },
        headers: {
          'Authorization': token
        }
      }
    );

    return response.data;
  } catch (error) {
    console.error('Error fetching media by type:', error);
    throw error;
  }
};

/**
 * Subir múltiples imágenes
 */
export const uploadMediaBulk = async (files, galleryType, token, onProgress) => {
  const successResults = [];
  const failedResults = [];

  for (let i = 0; i < files.length; i++) {
    try {
      const file = files[i];

      const formData = new FormData();
      formData.append('file', file);
      formData.append('galleryType', galleryType);

      const response = await axios.post(
        `${BASE_URL}media/`,
        formData,
        {
          headers: {
            'Authorization': token,
            'Content-Type': 'multipart/form-data'
          }
        }
      );

      successResults.push({
        fileName: file.name,
        data: response.data
      });

    } catch (error) {
      console.error(`Error uploading ${files[i].name}:`, error);
      failedResults.push({
        fileName: files[i].name,
        error: error.message
      });
    }

    // Actualizar progreso
    if (onProgress) {
      const progress = Math.round(((i + 1) / files.length) * 100);
      onProgress(progress);
    }
  }

  return {
    successCount: successResults.length,
    failedCount: failedResults.length,
    successful: successResults,
    failed: failedResults
  };
};

/**
 * Eliminar una imagen
 */
export const deleteMedia = async (mediaId, token) => {
  try {
    const response = await axios.delete(
      `${BASE_URL}media/${mediaId}/`,
      {
        headers: {
          'Authorization': token
        }
      }
    );

    return response.data;
  } catch (error) {
    console.error('Error deleting media:', error);
    throw error;
  }
};

/**
 * Obtener todas las imágenes (admin): GET media/?scope=all. Conserva la forma
 * { count, media } que devolvía el antiguo Media/all/.
 */
export const getAllMedia = async (token) => {
  try {
    const response = await axios.get(
      `${BASE_URL}media/`,
      {
        params: { scope: 'all' },
        headers: {
          'Authorization': token
        }
      }
    );

    return { count: response.data.length, media: response.data };
  } catch (error) {
    console.error('Error fetching all media:', error);
    throw error;
  }
};
